import React, { useState } from "react";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";

const Layout = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <div style={{ 
      display: 'flex', 
      height: '100vh', 
      width: '100vw',
      backgroundColor: '#f4f6f9',
      overflow: 'hidden', 
    }}>
      
      <div style={{
        width: sidebarCollapsed ? '78px' : '250px',
        height: '100vh',
        transition: 'width 0.3s ease',
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden', 
      }}>
        <Sidebar 
          collapsed={sidebarCollapsed} 
          onToggle={() => setSidebarCollapsed(!sidebarCollapsed)} 
        />
      </div>

      <div style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        minWidth: 0,
        height: '100vh', 
        overflow: 'hidden',
      }}>
        
        <div style={{
          flexShrink: 0,
          width: '100%'
        }}>
          <Navbar 
            sidebarCollapsed={sidebarCollapsed}
            onToggleSidebar={() => setSidebarCollapsed(!sidebarCollapsed)}
          />
        </div>

        <div style={{
          flex: 1,
          minHeight: 0,
          padding: '10px',
          overflow: 'auto',
        }}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Layout;